<ng-container *ngFor="let item of statesRef">
  <ng-container *ngIf="(state.switcherState === item?.id)
    || (!state.switcherState && item.default)">
    <ng-template [ngTemplateOutlet]="item?.templateRef">
    </ng-template>
  </ng-container>
</ng-container>
